// @ts-nocheck
import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import InputMask from "react-input-mask";

// import { Container } from './styles';

interface IFormInput {
    id?: string;
    name: string;
    label: string;
    control: any;
    error: any;
    mask: string;
    disabled?: boolean;
}

const textField: React.FC<IFormInput> = ({ id, name, label, control, error, mask, disabled }) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <InputMask {...field} mask={mask} disabled={disabled}>
                    {(props: JSX.IntrinsicAttributes) => {
                        return (
                            <TextField
                                id={id}
                                {...props}
                                disabled={disabled}
                                fullWidth
                                label={label}
                                error={!!error && !!error[name]}
                                helperText={!!error && error[name]?.message}
                                size="small"
                                margin="normal"
                            />
                        );
                    }}
                </InputMask>
            )}
        />
    );
};

export default textField;
